import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Card, Divider, Typography, TextField } from "@material-ui/core"
import * as Adm from "@adm"
import { spacing } from "@material-ui/system"

import styled from "styled-components/macro"
import { editTurnstileApi } from "../../../api/turnstileApi"
import { useHistory } from "react-router-dom"
import CloseIcon from "@material-ui/icons/Close"

const useStyles = makeStyles({
  customRendeGridClasses: {
    marginLeft: 8,
    marginBottom: 5,
    marginTop: 5,
  },
  SmallTextField: {
    width: "92px",
    marginRight: "10px",
    "& .MuiFormHelperText-contained": {
      marginLeft: "0px",
    },
  },
  SmallTextField2: {
    width: "92px",
    marginLeft: "10px",
    marginRight: "10px",
    "& .MuiFormHelperText-contained": {
      marginLeft: "0px",
    },
  },
  labelStyles: {
    fontSize: 14,
    fontWeight: 500,
    color: "#000000",
  },
  valueStyles: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    wordWrap: "break-word",
  },
  textField: {
    "& .MuiFormHelperText-contained": {
      marginLeft: "0px",
    },
  },
})

const customRenderContainer = ({
  classes,
  edit,
  turnstileDetails,
  handleInputChange,
  clickTheCheckMark,
}) => {
  return (
    <>
      <Grid item md={12}>
        <Divider />
      </Grid>
      <Grid
        container
        xs={12}
        className={classes.customRendeGridClasses}
        spacing={6}
      >
        <Grid item md={6}>
          <Typography variant="button" className={classes.labelStyles}>
            Turnstile port
          </Typography>
        </Grid>
        <Grid item md={6}>
          {!edit ? (
            <TextField
              type="text"
              className={classes.textField}
              variant="outlined"
              name="turnstileport"
              placeholder="Turnstile port"
              error={
                clickTheCheckMark && turnstileDetails.turnstileport === null
                  ? true
                  : clickTheCheckMark &&
                    turnstileDetails.turnstileport !== null &&
                    turnstileDetails.turnstileport.toString().length === 0
                  ? true
                  : false
              }
              helperText={
                clickTheCheckMark && turnstileDetails.turnstileport === null
                  ? "Enter Port Number"
                  : clickTheCheckMark &&
                    turnstileDetails.turnstileport !== null &&
                    turnstileDetails.turnstileport.toString().length === 0
                  ? "Enter Port Number"
                  : false
              }
              size="small"
              value={turnstileDetails.turnstileport}
              onChange={(e) => handleInputChange(e)}
            />
          ) : (
            <Typography className={classes.valueStyles}>
              {turnstileDetails &&
                turnstileDetails.turnstileport &&
                turnstileDetails.turnstileport}
            </Typography>
          )}
        </Grid>
        <Grid item md={12}>
          <Divider />
        </Grid>
        <Grid item md={6}>
          <Typography variant="button" className={classes.labelStyles}>
            Coordinates
          </Typography>
        </Grid>
        <Grid item md>
          {!edit ? (
            <Grid style={{ display: "flex" }}>
              <TextField
                type="text"
                className={classes.SmallTextField}
                variant="outlined"
                name="CoordinatesX"
                error={
                  clickTheCheckMark && turnstileDetails.CoordinatesX === null
                    ? true
                    : clickTheCheckMark &&
                      turnstileDetails.CoordinatesX !== null &&
                      turnstileDetails.CoordinatesX.toString().length === 0
                    ? true
                    : false
                }
                helperText={
                  clickTheCheckMark && turnstileDetails.CoordinatesX === null
                    ? "Enter X-axis"
                    : clickTheCheckMark &&
                      turnstileDetails.CoordinatesX !== null &&
                      turnstileDetails.CoordinatesX.toString().length === 0
                    ? "Enter X-axis"
                    : false
                }
                placeholder="X"
                size="small"
                value={turnstileDetails.CoordinatesX}
                onChange={(e) => handleInputChange(e)}
              />
              <div>
                <CloseIcon style={{ fontSize: 15, marginTop: 10 }} />
              </div>
              <TextField
                type="text"
                className={classes.SmallTextField2}
                variant="outlined"
                name="CoordinatesY"
                error={
                  clickTheCheckMark && turnstileDetails.CoordinatesY === null
                    ? true
                    : clickTheCheckMark &&
                      turnstileDetails.CoordinatesY !== null &&
                      turnstileDetails.CoordinatesY.toString().length === 0
                    ? true
                    : false
                }
                helperText={
                  clickTheCheckMark && turnstileDetails.CoordinatesY === null
                    ? "Enter Y-axis"
                    : clickTheCheckMark &&
                      turnstileDetails.CoordinatesY !== null &&
                      turnstileDetails.CoordinatesY.toString().length === 0
                    ? "Enter Y-axis"
                    : false
                }
                placeholder="Y"
                size="small"
                value={turnstileDetails.CoordinatesY}
                onChange={(e) => handleInputChange(e)}
              />
            </Grid>
          ) : (
            <Typography variant="h3">
              <Grid style={{ display: "flex" }}>
                <Typography variant="h3" className={classes.valueStyles}>
                  {turnstileDetails &&
                    turnstileDetails.CoordinatesX &&
                    turnstileDetails.CoordinatesX}
                </Typography>
                <div>
                  {turnstileDetails &&
                    turnstileDetails.CoordinatesX &&
                    turnstileDetails.CoordinatesY && (
                      <CloseIcon style={{ fontSize: 15, marginBottom: 3 }} />
                    )}
                </div>
                <Typography variant="h3" className={classes.valueStyles}>
                  {turnstileDetails &&
                    turnstileDetails.CoordinatesY &&
                    turnstileDetails.CoordinatesY}{" "}
                </Typography>
              </Grid>
            </Typography>
          )}
        </Grid>
        <Grid item md={12}>
          <Divider />
        </Grid>
        <Grid item md={6}>
          <Typography variant="button" className={classes.labelStyles}>
            Reset time
          </Typography>
        </Grid>
        <Grid item md={6}>
          {!edit ? (
            <TextField
              type="text"
              className={classes.textField}
              error={
                clickTheCheckMark && turnstileDetails.ResetTime === null
                  ? true
                  : clickTheCheckMark &&
                    turnstileDetails.ResetTime !== null &&
                    turnstileDetails.ResetTime.toString().length === 0
                  ? true
                  : false
              }
              helperText={
                clickTheCheckMark && turnstileDetails.ResetTime === null
                  ? "Enter Reset Time"
                  : clickTheCheckMark &&
                    turnstileDetails.ResetTime !== null &&
                    turnstileDetails.ResetTime.toString().length === 0
                  ? "Enter Reset Time"
                  : false
              }
              variant="outlined"
              name="ResetTime"
              placeholder="Reset Time"
              size="small"
              value={turnstileDetails.ResetTime}
              onChange={(e) => handleInputChange(e)}
            />
          ) : (
            <Typography className={classes.valueStyles}>
              {turnstileDetails &&
                turnstileDetails.ResetTime &&
                turnstileDetails.ResetTime}
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  )
}
const OtherDetails = ({
  turnstileDetails,
  handleInputChange,
  discardChangesOfOtherEle,
  setAlertMessage,
  setAlert,
  setAlertType,
}) => {
  const classes = useStyles()
  const [edit, setEdit] = useState(true)
  const history = useHistory()
  const [clickTheCheckMark, setClickTheCheckMark] = useState(false)

  const validFunc = (turnstileDetails) => {
    if (
      turnstileDetails.ResetTime &&
      turnstileDetails.ResetTime.toString().length > 0 &&
      turnstileDetails.CoordinatesY &&
      turnstileDetails.CoordinatesY.toString().length > 0 &&
      turnstileDetails.CoordinatesX &&
      turnstileDetails.CoordinatesX.toString().length > 0 &&
      turnstileDetails.turnstileport &&
      turnstileDetails.turnstileport.toString().length > 0 &&
      turnstileDetails.turnstileIP &&
      turnstileDetails.turnstileloc &&
      turnstileDetails.turnstileIP.toString().length > 0 &&
      turnstileDetails.turnstileloc.toString().length > 0
    ) {
      return true
    } else {
      return false
    }
  }
  const onUpdateData = (
    turnstileDetails,
    history,
    setAlertMessage,
    setAlert,
    setAlertType
  ) => {
    editTurnstileApi(
      turnstileDetails,
      history,
      setAlertMessage,
      setAlert,
      setAlertType
    )
  }
  return (
    <>
      <Card
        style={{
          width: "100%",
          boxShadow:
            " 0px 0px 0px rgba(63, 63, 68, 0.05), 0px 1px 2px rgba(63, 63, 68, 0.15)",
          borderRadius: "8px",
          height: "min-content",
        }}
      >
        <Adm.AccordianPanel
          renderContainer={(containerProps) =>
            customRenderContainer({
              ...containerProps,
              classes,
              edit,
              turnstileDetails,
              handleInputChange,
              clickTheCheckMark,
            })
          }
          label="Other Details"
          isWriteAllowed={true}
          resetData={() => discardChangesOfOtherEle()}
          edit={edit}
          setEdit={setEdit}
          updateData={() => {
            setClickTheCheckMark(true)
            if (validFunc(turnstileDetails)) {
              onUpdateData(
                turnstileDetails,
                history,
                setAlertMessage,
                setAlert,
                setAlertType
              )
            }
          }}
        />
      </Card>
    </>
  )
}
export default OtherDetails
